import React, { useState, useEffect } from "react";
import imageOne from '../../resource/events/calendar/1.png'
import imageThree from '../../resource/events/calendar/2.png'
import Calendar from '../Calendar/Calendar'
import apiClient from "@/api/client";

const EventCalendor = () => {
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState({
        title: "Select a date to view event details",
        date: "",
        location: "",
        time: "",
        description: "",
        organizer: "",
        category: "",
        tags: "",
        url: "",
        other_details: ""
    });
    const [loading, setLoading] = useState(true);

    // Fetch events from API
    useEffect(() => {
        const fetchEvents = async () => {
            try {
                // Replace with your actual API endpoint
                const response = await apiClient.get('/events');
                const data = response.data;

                if (data.message === "Events retrieved successfully.") {
                    setEvents(data.data || data); // Adjust based on your API response structure
                }
            } catch (error) {
                console.error('Error fetching events:', error);
                // Fallback to empty array if API fails
                setEvents([]);
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, []);

    // Function to format date from API format to display format
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    // Function to format time from API format
    const formatTime = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const startTime = start.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        const endTime = end.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });

        return `${startTime} to ${endTime}`;
    };

    // Function to get date in YYYY-MM-DD format for comparison
    const getDateKey = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };

    // Create events object for calendar markers
    const getEventMarkers = () => {
        const markers = {};
        events.forEach(event => {
            const dateKey = getDateKey(event.start_date);
            // You can customize colors based on category
            markers[dateKey] = getMarkerColor(event.category);
        });
        return markers;
    };

    // Function to determine marker color based on event category
    const getMarkerColor = (category) => {
        switch (category?.toLowerCase()) {
            case 'conference': return 'purple';
            case 'ceremony': return 'yellow';
            case 'workshop': return 'gold';
            case 'gathering': return 'small-yellow';
            case 'blessing': return 'half-yellow-purple';
            default:
                return 'purple';
        }
    };

    const handleDateSelect = (dateString) => {
        // Find event for the selected date
        const selectedDateEvent = events.find(event => {
            const eventDate = getDateKey(event.start_date);
            return eventDate === dateString;
        });

        if (selectedDateEvent) {
            setSelectedEvent({
                title: selectedDateEvent.title,
                date: formatDate(selectedDateEvent.start_date),
                location: selectedDateEvent.location_details,
                time: formatTime(selectedDateEvent.start_date, selectedDateEvent.end_date),
                description: selectedDateEvent.description,
                organizer: selectedDateEvent.organizer,
                category: selectedDateEvent.category,
                tags: selectedDateEvent.tags,
                url: selectedDateEvent.url,
                other_details: selectedDateEvent.other_details
            });
        } else {
            // Default event for dates without specific events
            setSelectedEvent({
                title: "No Event Scheduled",
                date: new Date(dateString).toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                }),
                location: "Please check back later",
                time: "N/A",
                description: "No events scheduled for this date.",
                organizer: "",
                category: "",
                tags: "",
                url: "",
                other_details: ""
            });
        }
    };

    if (loading) {
        return (
            <div className="securespot-page inside-pages">
                <div className="p-4 text-center">
                    <h1 className='font-main dark-gold'>Loading Events...</h1>
                </div>
            </div>
        );
    }

    return (
        <div className="securespot-page inside-pages">
            <div className="right-box">
                <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
            </div>

            <h1 className='font-main dark-gold p-4 mt-4'>Event Calendar</h1>

            <div className="poem-1 mt-6 h4-bold dark-gold ">
                <div>
                    <p>The Triple Gem in the Mind</p>
                    <p className="mt-5">The Buddha, Dhamma, Sangha</p>
                    <p> The Triple Gem in mind,</p>
                    <p>In holy Buddhist events,</p>
                    <p >Faith we shall find.</p>
                    <p >Mark the Dhamma dates, </p>
                    <p >Embrace with a smile,</p>
                    <p>Gaining peace and harmony </p>
                    <p >With every step, every mile.</p>
                </div>
            </div>

            <div className="p-4 mt-6 text-center">
                <h3 className='mt-4 font-second dark-gold'>Calendar</h3>
                <div className="calander-box mt-6 ">
                    <div className="cl-right">
                        <div className="calnder text-center mt-5">
                            <Calendar
                                onDateSelect={handleDateSelect}
                                eventMarkers={getEventMarkers()}
                                blockEventDates={false}
                            />
                        </div>
                    </div>
                    <div className="cl-details bg-white rounded-lg shadow-sm border border-gray-100 p-4">
                        {/* Event Title */}
                        <div className=" text-white p-4 rounded-t-lg">
                            <h3 className="text-xl font-bold text-center text-black">{selectedEvent.title}</h3>
                        </div>

                        {/* Event Details */}
                        <div className="custom-padding space-y-4">
                            {/* Date */}
                            <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg mt-4">

                                <div>
                                    <span className=" text-sm font-extrabold text-black font-b">Date : </span>
                                    <span className="text-black">{selectedEvent.date}</span>
                                </div>
                            </div>

                            {/* Location */}
                            <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">

                                <div>
                                    <span className="block text-sm font-semibold text-black">Location : </span>
                                    <span className="text-black">{selectedEvent.location}</span>
                                </div>
                            </div>

                            {/* Time */}
                            <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">

                                <div>
                                    <span className="block text-sm font-semibold text-black">Time : </span>
                                    <span className="text-black">{selectedEvent.time}</span>
                                </div>
                            </div>

                            {/* Description */}
                            {selectedEvent.description && (
                                <div className="p-3 bg-yellow-50 border-l-4 border-yellow-500 rounded-lg">
                                    <div className="flex items-start space-x-3">

                                        <div className="flex-1">
                                            <span className="block text-sm font-semibold text-black mb-2">Description : </span>
                                            <p className="text-black leading-relaxed">{selectedEvent.description}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Organizer */}
                            {selectedEvent.organizer && (
                                <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">

                                    <div>
                                        <span className="block text-sm font-semibold text-black">Organizer : </span>
                                        <span className="text-black">{selectedEvent.organizer}</span>
                                    </div>
                                </div>
                            )}

                            {/* Category */}
                            {selectedEvent.category && (
                                <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">

                                    <div>
                                        <span className="block text-sm font-semibold text-black">Category : </span>
                                        <span className="inline-block text-black px-3 py-1 rounded-full text-sm font-medium">
                                            {selectedEvent.category}
                                        </span>
                                    </div>
                                </div>
                            )}

                            {/* Additional Details */}
                            {selectedEvent.other_details && (
                                <div className="p-3 bg-blue-50 border-l-4 border-blue-500 rounded-lg">
                                    <div className="flex items-start space-x-3">

                                        <div className="flex-1">
                                            <span className="block text-sm font-semibold text-black mb-2">Additional Details : </span>
                                            <p className="text-black leading-relaxed">{selectedEvent.other_details}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* More Information Link */}
                            {/* {selectedEvent.url && selectedEvent.url !== "" && (
            <div className="pt-4 border-t border-gray-100">
                <a
                    href={selectedEvent.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white font-medium rounded-lg transition-colors duration-200"
                >
                    <span>More Information</span>
                    
                </a>
            </div>
        )} */}
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-4 mt-6 text-center">
                <div className="mt-6 calander-box align-item-center">
                    <div className="c-details text-left">
                        <h2 className='intro-text '>Further More Details : </h2>
                        <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                        <p className="font-p">Mr Gamini : 0422 069 359</p>
                        <p className="font-p">WhatsApp : 0422 069 359</p>
                        <p className="font-p">E-mail : info@bvp.org.au</p>
                    </div>
                </div>
            </div>

            <div className="bottom-box mt-6">
                <img src={imageThree} alt="bottom-image" width={600} />
            </div>
        </div>
    )
}

export default EventCalendor